module.exports = __webpack_public_path__ + "static/media/(110008).9089102a.jpg";